type UrlForwardArgs = {
    fullUrlString: string;
    pathRoot: string;
};
export function urlForward({ fullUrlString, pathRoot }: UrlForwardArgs): string {
    if (fullUrlString) {
        const searchParams = new URLSearchParams();
        searchParams.append('goTo', fullUrlString);
        return `${pathRoot}?${searchParams.toString()}`;
    }

    return pathRoot;
}
